module.exports = __webpack_public_path__ + "static/media/ok.0636ce15.svg";